import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';

import { hidden } from './DocumentTitleHeader.scss';

interface Props {
  title: React.ReactNode;
}

const DocumentTitleHeader: React.FC<Props> = ({ title }) => {
  const headerRef = useRef<HTMLHeadingElement>(null);

  return (
    <>
      <Helmet>{headerRef.current && <title>{headerRef.current.innerText}</title>}</Helmet>
      <h2 ref={headerRef} className={hidden}>
        {title}
      </h2>
    </>
  );
};
export default DocumentTitleHeader;
